import { formatDateTime, formatEmptyValue } from '../../utils/common'
import Tooltip from '../common/tooltip'

const UsageReportRow = (props) => {
  return (
    <div className="flex flex-row flex-wrap items-center bg-white w-full py-2 px-3 border-b border-tracer-dark-blue text-black">
      <div className="flex flex-row w-full items-center">
        <div className="w-3/12 pl-10">{formatDateTime(props.created_at)}</div>
        <div className="flex w-3/12 items-center table_text">
          <Tooltip message={props.user_name}>
            <div>{props.user_name}</div>
          </Tooltip>
        </div>
        <div className="flex w-6/12 items-center">
          <Tooltip message={props.activity}>
            <div>{props.activity}</div>
          </Tooltip>
        </div>
        {/* <div className="flex w-2/12 items-center table_text">
          <Tooltip message={props.target_model}>
            <div>{props.target_model}</div>
          </Tooltip>
        </div> */}
      </div>
    </div>
  )
}

export default UsageReportRow
